export const parseEvents = (events = [])=>events.map((event)=>{
        if (!event.legend.class) event.legend.class = 'flatpickr-day-footer-literal';
        if (!event.date.class) event.date.class = 'flatpickr-day--direct-flight';
        return event;
    });

//# sourceMappingURL=utils.js.map